import type { CSSProperties, FC, SVGProps } from 'react';

import React from 'react';
import SvgComponent from './spinner-svg';

type MergeSVGProps<Element, Props> = Omit<SVGProps<Element>, keyof Props> & Props;

type SpinnerProps = {
  /**
   * Size
   * Will be applied to width and height
   * @default 80px
   */
  size?: string | number;

  /**
   * The stroke width to apply
   * @default 3
   */
  strokeWidth?: number;

  /**
   * Animate via css?
   * @default to inline SVG animation (<animateTransform>)
   */
  useCSS?: boolean;
};

type SpinnerComponentProps = MergeSVGProps<SVGSVGElement, SpinnerProps>;

export const Spinner: FC<SpinnerComponentProps> = ({ size = 80, strokeWidth, ...svgProps }) => {
  const styles: CSSProperties = {
    width: size,
    height: size,
    overflow: 'visible',
    ...(!!strokeWidth && {
      ['--spinner-stroke-width' as any]: strokeWidth,
    }),
  };

  return <SvgComponent {...svgProps} style={styles} />;
};
